import styled from "styled-components";

export const StyledBurger = styled.button`
display:none;
@media screen and (max-width: 800px) {
position: absolute;
top: 5%;
right: 2rem;
display: flex;
flex-direction: column;
justify-content: space-around;
width: 2rem;
height: 2rem;
background: transparent;
border: none;
cursor: pointer;
padding: 0;
z-index: 5000;

&:focus {
  outline: none;
}

div {
  width: 2rem;
  height: 0.25rem;
  // background: ${({ theme }) => theme.primary1};
  background:${({ open }) => (open ? "#1f3a73" : "#fff")};
  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;

  :first-child {
    transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
  }
  :nth-child(2){
    opacity: ${({ open }) => (open ? "0" : "1")};
    transform: ${({ open }) => (open ? "translateX(20px)" : "translateX(0)")};
  }
  :nth-child(3){
    transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")}
  }
}
`;
